import { useSelector } from "react-redux";

// Api
import { gamesApi } from "redux/game/api";

// Components
import GameHistoryEmpty from "components/molecules/GameHistoryEmpty";
import GameList from "components/organisms/GameList";

// Hooks
import { useLoaderStore } from "stores/loader";

// Selectors
import * as gameSelectors from "redux/game/selectors";
import { usePlatform } from "../../hooks/usePlatform";

const GameHistoryContainer = () => {
  // const { isLoading } = gamesApi.useHistoryQuery("");
  const platform = usePlatform();

  const { isLoading: newLoading } = gamesApi.useNewHistoryQuery(platform);
  const { overlayLoading } = useLoaderStore();

  // const history = useSelector(gameSelectors.history);
  const history = useSelector(gameSelectors.newHistory);
  return (
    <>
      {!history || (history && !history.length && <GameHistoryEmpty />)}
      {history && history.length ? (
        <GameList
          list={history}
          isAutoLoading={false}
          take={null}
          isLoading={newLoading}
          isOverlayLoading={overlayLoading}
        />
      ) : null}
    </>
  );
};

export default GameHistoryContainer;
